/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const retrieveVideo = /* GraphQL */ `
  mutation RetrieveVideo($input: RetrieveVideoInput) {
    retrieveVideo(input: $input)
  }
`;
export const updateTimestreamData = /* GraphQL */ `
  mutation UpdateTimestreamData($input: updateTimestreamDataInput!) {
    updateTimestreamData(input: $input)
  }
`;
export const deleteFolderFromS3 = /* GraphQL */ `
  mutation DeleteFolderFromS3($folderPath: String!) {
    deleteFolderFromS3(folderPath: $folderPath)
  }
`;
export const createSecretsManagerSecret = /* GraphQL */ `
  mutation CreateSecretsManagerSecret(
    $input: createSecretsManagerSecretInput!
  ) {
    createSecretsManagerSecret(input: $input)
  }
`;
export const deleteVideo = /* GraphQL */ `
  mutation DeleteVideo($input: DeleteVideoInput!) {
    deleteVideo(input: $input) {
      id
      customerId
      clientId
      groupId
      videoName
      videoMethod
      windspeed
      geometry
      fov
      isVideoProcessed
      annotations
      sourceS3Key
      modelOutputS3Key
      notes
      outputMeasurement
      videoState
    }
  }
`;
export const updateVideoNotes = /* GraphQL */ `
  mutation UpdateVideoNotes($input: UpdateVideoNotesInput!) {
    updateVideoNotes(input: $input) {
      id
      customerId
      clientId
      groupId
      videoName
      videoMethod
      windspeed
      geometry
      fov
      isVideoProcessed
      annotations
      sourceS3Key
      modelOutputS3Key
      notes
      outputMeasurement
      videoState
    }
  }
`;
export const addClientGroup = /* GraphQL */ `
  mutation AddClientGroup($input: AddClientGroupInput) {
    addClientGroup(input: $input) {
      id
      customerId
      clientId
      groupName
      createdAt
    }
  }
`;
export const deleteClientGroup = /* GraphQL */ `
  mutation DeleteClientGroup($input: DeleteClientGroupInput) {
    deleteClientGroup(input: $input) {
      id
      customerId
      clientId
      groupName
      createdAt
    }
  }
`;
export const updateClientGroup = /* GraphQL */ `
  mutation UpdateClientGroup($input: UpdateClientGroupInput) {
    updateClientGroup(input: $input) {
      id
      customerId
      clientId
      groupName
      createdAt
    }
  }
`;
export const addClient = /* GraphQL */ `
  mutation AddClient($input: AddClientInput!) {
    addClient(input: $input) {
      id
      clientName
      customerId
    }
  }
`;
export const deleteClient = /* GraphQL */ `
  mutation DeleteClient($input: DeleteClientInput!) {
    deleteClient(input: $input) {
      id
      clientName
      customerId
    }
  }
`;
export const updateClient = /* GraphQL */ `
  mutation UpdateClient($input: UpdateClientInput!) {
    updateClient(input: $input) {
      id
      clientName
      customerId
    }
  }
`;
export const batchAddServices = /* GraphQL */ `
  mutation BatchAddServices($input: [AddServiceInput!]!) {
    batchAddServices(input: $input) {
      nodeId
      customerId
      locationId
      deviceId
      serviceType
      configuration
      id
      healthData
      isRunning
      modelAlertSettingsId
      modelAlertSettings {
        id
        serviceId
        customerId
        deviceId
        timeZone
        modelAlertParameters {
          objectType
          enabled
          activeDays
          schedules {
            dayOfWeek
            dailyTimeRange {
              startMinutesFromMidnight
              endMinutesFromMidnight
            }
          }
        }
      }
    }
  }
`;
export const batchAddDevices = /* GraphQL */ `
  mutation BatchAddDevices($input: [AddDeviceInput!]!) {
    batchAddDevices(input: $input) {
      customerId
      locationId
      locationName
      id
      name
      status
      nodeId
      nodeName
      makeModelId
      cameraIpAddress
      deviceData {
        hasPanTilt
        hasRecordVideo
        hasZoom
        keyFrame
        panTiltIP
        protocol
        recentFrame
        rtspHost
        sourceVideo
        signedUrlKeyFrame
        signedUrlRecentFrame
      }
      currentPosition {
        pan
        tilt
        zoom
      }
      healthData {
        lastAlive
        isOnline
      }
    }
  }
`;
export const batchAddCategory = /* GraphQL */ `
  mutation BatchAddCategory($input: [AddCategoryInput!]!) {
    batchAddCategory(input: $input) {
      id
      categoryName
      isAlertEnabled
    }
  }
`;
export const batchAddVideos = /* GraphQL */ `
  mutation BatchAddVideos($input: AddVideosInput) {
    batchAddVideos(input: $input) {
      id
      customerId
      clientId
      groupId
      videoName
      videoMethod
      windspeed
      geometry
      fov
      isVideoProcessed
      annotations
      sourceS3Key
      modelOutputS3Key
      notes
      outputMeasurement
      videoState
    }
  }
`;
export const batchDeleteVideos = /* GraphQL */ `
  mutation BatchDeleteVideos($input: [BatchDeleteVideosInput!]!) {
    batchDeleteVideos(input: $input) {
      id
      groupId
    }
  }
`;
export const batchDeleteClientGroups = /* GraphQL */ `
  mutation BatchDeleteClientGroups($input: [BatchDeleteClientGroupsInput!]!) {
    batchDeleteClientGroups(input: $input) {
      id
      customerId
      clientId
      groupName
      createdAt
    }
  }
`;
export const batchAddLicensePlate = /* GraphQL */ `
  mutation BatchAddLicensePlate($input: [AddLicensePlateInput!]!) {
    batchAddLicensePlate(input: $input) {
      id
      categoryId
      company
      driverName
      licensePlate
    }
  }
`;
export const addLicensePlate = /* GraphQL */ `
  mutation AddLicensePlate($input: AddLicensePlateInput!) {
    addLicensePlate(input: $input) {
      id
      categoryId
      company
      driverName
      licensePlate
    }
  }
`;
export const updateLicensePlateWithNewCategory = /* GraphQL */ `
  mutation UpdateLicensePlateWithNewCategory($input: UpdateLicensePlate!) {
    updateLicensePlateWithNewCategory(input: $input) {
      id
      categoryId
      company
      driverName
      licensePlate
    }
  }
`;
export const deleteLicensePlate = /* GraphQL */ `
  mutation DeleteLicensePlate($input: DeleteLicensePlate!) {
    deleteLicensePlate(input: $input) {
      id
      categoryId
      company
      driverName
      licensePlate
    }
  }
`;
export const addCategory = /* GraphQL */ `
  mutation AddCategory($input: AddCategoryInput!) {
    addCategory(input: $input) {
      id
      categoryName
      isAlertEnabled
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory($input: UpdateCategory!) {
    updateCategory(input: $input) {
      id
      categoryName
      isAlertEnabled
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory($input: DeleteCategory!) {
    deleteCategory(input: $input) {
      id
      categoryName
      isAlertEnabled
    }
  }
`;
export const addTag = /* GraphQL */ `
  mutation AddTag($input: AddTagInput!) {
    addTag(input: $input) {
      id
      tagName
    }
  }
`;
export const deleteTag = /* GraphQL */ `
  mutation DeleteTag($input: DeleteTagInput!) {
    deleteTag(input: $input) {
      id
      tagName
    }
  }
`;
export const batchAddTagAssociations = /* GraphQL */ `
  mutation BatchAddTagAssociations($input: BatchAddTagAssociationsInput) {
    batchAddTagAssociations(input: $input) {
      id
      associationId
      tagName
    }
  }
`;
export const syncShadow = /* GraphQL */ `
  mutation SyncShadow($nodeId: String!) {
    syncShadow(nodeId: $nodeId) {
      customerId
      locationId
      id
      nodeName
      nodeId
      level
      referenceId
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
      }
      serviceData
      deviceData
      onboardCommand
      tags {
        id
        tagName
      }
      nodeIP
      isOnline
    }
  }
`;
export const sendNodeConfigIam = /* GraphQL */ `
  mutation SendNodeConfigIam($nodeId: String!) {
    sendNodeConfigIam(nodeId: $nodeId) {
      customerId
      locationId
      id
      nodeName
      nodeId
      level
      referenceId
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
      }
      serviceData
      deviceData
      onboardCommand
      tags {
        id
        tagName
      }
      nodeIP
      isOnline
    }
  }
`;
export const addDTObject = /* GraphQL */ `
  mutation AddDTObject($input: DTObjectInput!) {
    addDTObject(input: $input) {
      id
      version
      objectId
      objectName
      objectType
      objectManufacturerName
      isCustomerObject
      filesInfo {
        id
        originalFileName
        contentType
        useType
        key
      }
    }
  }
`;
export const addCustomerDTObject = /* GraphQL */ `
  mutation AddCustomerDTObject($input: DTObjectInput!) {
    addCustomerDTObject(input: $input) {
      id
      version
      objectId
      objectName
      objectType
      objectManufacturerName
      isCustomerObject
      filesInfo {
        id
        originalFileName
        contentType
        useType
        key
      }
    }
  }
`;
export const updateCustomerDTObject = /* GraphQL */ `
  mutation UpdateCustomerDTObject($input: DTObjectInput!) {
    updateCustomerDTObject(input: $input) {
      id
      version
      objectId
      objectName
      objectType
      objectManufacturerName
      isCustomerObject
      filesInfo {
        id
        originalFileName
        contentType
        useType
        key
      }
    }
  }
`;
export const deleteCustomerDTObject = /* GraphQL */ `
  mutation DeleteCustomerDTObject($input: DeleteDTObjectInput!) {
    deleteCustomerDTObject(input: $input) {
      id
      version
      objectId
      objectName
      objectType
      objectManufacturerName
      isCustomerObject
      filesInfo {
        id
        originalFileName
        contentType
        useType
        key
      }
    }
  }
`;
export const uploadDTFile = /* GraphQL */ `
  mutation UploadDTFile(
    $customerId: String
    $objectId: String!
    $file: UploadFileInput!
  ) {
    uploadDTFile(customerId: $customerId, objectId: $objectId, file: $file) {
      key
      url
    }
  }
`;
export const uploadDTFiles = /* GraphQL */ `
  mutation UploadDTFiles(
    $customerId: String
    $objectId: String!
    $files: [UploadFileInput!]!
  ) {
    uploadDTFiles(customerId: $customerId, objectId: $objectId, files: $files) {
      key
      url
    }
  }
`;
export const reportLoaderProgress = /* GraphQL */ `
  mutation ReportLoaderProgress($event: LoaderProgressInput!) {
    reportLoaderProgress(event: $event) {
      jobId
      percent
      page
      rowsTotal
      message
    }
  }
`;
export const addDTProject = /* GraphQL */ `
  mutation AddDTProject($input: AddDTProjectInput!) {
    addDTProject(input: $input) {
      id
      projectId
      customerId
      displayName
      lastModifierUserName
      lastModificationDate
      configURL
      withKMZLayer
      kmzLayerURL
      measurementSystem
    }
  }
`;
export const updateDTProject = /* GraphQL */ `
  mutation UpdateDTProject($input: UpdateDTProjectInput!) {
    updateDTProject(input: $input) {
      id
      projectId
      customerId
      displayName
      lastModifierUserName
      lastModificationDate
      configURL
      withKMZLayer
      kmzLayerURL
      measurementSystem
    }
  }
`;
export const deleteDTProject = /* GraphQL */ `
  mutation DeleteDTProject($input: DeleteDTProjectInput!) {
    deleteDTProject(input: $input) {
      id
      projectId
      customerId
      displayName
      lastModifierUserName
      lastModificationDate
      configURL
      withKMZLayer
      kmzLayerURL
      measurementSystem
    }
  }
`;
export const updateShadowNode = /* GraphQL */ `
  mutation UpdateShadowNode(
    $thingName: String
    $shadowName: String
    $payload: AWSJSON
  ) {
    updateShadowNode(
      thingName: $thingName
      shadowName: $shadowName
      payload: $payload
    ) {
      shadow
    }
  }
`;
export const addService = /* GraphQL */ `
  mutation AddService($input: AddServiceInput!) {
    addService(input: $input) {
      nodeId
      customerId
      locationId
      deviceId
      serviceType
      configuration
      id
      healthData
      isRunning
      modelAlertSettingsId
      modelAlertSettings {
        id
        serviceId
        customerId
        deviceId
        timeZone
        modelAlertParameters {
          objectType
          enabled
          activeDays
          schedules {
            dayOfWeek
            dailyTimeRange {
              startMinutesFromMidnight
              endMinutesFromMidnight
            }
          }
        }
      }
    }
  }
`;
export const updateService = /* GraphQL */ `
  mutation UpdateService($input: UpdateServiceInput!) {
    updateService(input: $input) {
      nodeId
      customerId
      locationId
      deviceId
      serviceType
      configuration
      id
      healthData
      isRunning
      modelAlertSettingsId
      modelAlertSettings {
        id
        serviceId
        customerId
        deviceId
        timeZone
        modelAlertParameters {
          objectType
          enabled
          activeDays
          schedules {
            dayOfWeek
            dailyTimeRange {
              startMinutesFromMidnight
              endMinutesFromMidnight
            }
          }
        }
      }
    }
  }
`;
export const deleteService = /* GraphQL */ `
  mutation DeleteService($input: DeleteServiceInput!) {
    deleteService(input: $input) {
      nodeId
      customerId
      locationId
      deviceId
      serviceType
      configuration
      id
      healthData
      isRunning
      modelAlertSettingsId
      modelAlertSettings {
        id
        serviceId
        customerId
        deviceId
        timeZone
        modelAlertParameters {
          objectType
          enabled
          activeDays
          schedules {
            dayOfWeek
            dailyTimeRange {
              startMinutesFromMidnight
              endMinutesFromMidnight
            }
          }
        }
      }
    }
  }
`;
export const setIsRunningServiceStatus = /* GraphQL */ `
  mutation SetIsRunningServiceStatus($input: SetServiceStatusInput!) {
    setIsRunningServiceStatus(input: $input) {
      nodeId
      customerId
      locationId
      deviceId
      serviceType
      configuration
      id
      healthData
      isRunning
      modelAlertSettingsId
      modelAlertSettings {
        id
        serviceId
        customerId
        deviceId
        timeZone
        modelAlertParameters {
          objectType
          enabled
          activeDays
          schedules {
            dayOfWeek
            dailyTimeRange {
              startMinutesFromMidnight
              endMinutesFromMidnight
            }
          }
        }
      }
    }
  }
`;
export const addAlertSubscription = /* GraphQL */ `
  mutation AddAlertSubscription($input: AddAlertSubscriptionInput!) {
    addAlertSubscription(input: $input) {
      entity
      email
    }
  }
`;
export const addAlertWildCardSubscription = /* GraphQL */ `
  mutation AddAlertWildCardSubscription(
    $input: AddAlertWildCardSubscriptionInput!
  ) {
    addAlertWildCardSubscription(input: $input) {
      wildCard
      entity
      email
    }
  }
`;
export const addZone = /* GraphQL */ `
  mutation AddZone($input: AddZoneInput!) {
    addZone(input: $input) {
      id
      name
      pan
      tilt
      deviceId
      status
      serviceId
      inspectTime
      keyFrame
      threshold {
        id
        name
        value
      }
      exclusions
      nodeId
      alertData
      zoom
      shouldNotify
      signedUrlKeyFrame
    }
  }
`;
export const addZoneThreshold = /* GraphQL */ `
  mutation AddZoneThreshold($input: AddZoneThresholdInput!) {
    addZoneThreshold(input: $input) {
      id
      name
      value
    }
  }
`;
export const addAnnotation = /* GraphQL */ `
  mutation AddAnnotation($input: AnnotationInput!) {
    addAnnotation(input: $input) {
      id
      serviceId
      deviceId
      zoneId
      polygon
      annotationType
      equipmentType
      annotateTanks
      name
      tankNumber
      tankHeight
      bottomHidden
    }
  }
`;
export const updateZone = /* GraphQL */ `
  mutation UpdateZone($input: UpdateZoneInput!) {
    updateZone(input: $input) {
      id
      name
      pan
      tilt
      deviceId
      status
      serviceId
      inspectTime
      keyFrame
      threshold {
        id
        name
        value
      }
      exclusions
      nodeId
      alertData
      zoom
      shouldNotify
      signedUrlKeyFrame
    }
  }
`;
export const updateModelAlertSettings = /* GraphQL */ `
  mutation UpdateModelAlertSettings($input: UpdateModelAlertSettingsInput!) {
    updateModelAlertSettings(input: $input) {
      id
      serviceId
      customerId
      deviceId
      timeZone
      modelAlertParameters {
        objectType
        enabled
        activeDays
        schedules {
          dayOfWeek
          dailyTimeRange {
            startMinutesFromMidnight
            endMinutesFromMidnight
          }
        }
      }
    }
  }
`;
export const updateZoneThresholdValue = /* GraphQL */ `
  mutation UpdateZoneThresholdValue($input: UpdateZoneThresholdValueInput!) {
    updateZoneThresholdValue(input: $input) {
      id
      name
      pan
      tilt
      deviceId
      status
      serviceId
      inspectTime
      keyFrame
      threshold {
        id
        name
        value
      }
      exclusions
      nodeId
      alertData
      zoom
      shouldNotify
      signedUrlKeyFrame
    }
  }
`;
export const updateZoneThresholdItem = /* GraphQL */ `
  mutation UpdateZoneThresholdItem($input: UpdateZoneThresholdItemInput!) {
    updateZoneThresholdItem(input: $input) {
      id
      name
      value
    }
  }
`;
export const updateAnnotation = /* GraphQL */ `
  mutation UpdateAnnotation($input: AnnotationInput!) {
    updateAnnotation(input: $input) {
      id
      serviceId
      deviceId
      zoneId
      polygon
      annotationType
      equipmentType
      annotateTanks
      name
      tankNumber
      tankHeight
      bottomHidden
    }
  }
`;
export const addAlertEmailNotification = /* GraphQL */ `
  mutation AddAlertEmailNotification($input: addAlertEmailNotificationInput) {
    addAlertEmailNotification(input: $input) {
      id
      alertName
      alertType
      locationTag
      location
      model
      email
      tag
      node
      customService
      jsonObject
      subscribedLevelEntity
      phoneNumber
      notificationSettingsJson
      createdBy
    }
  }
`;
export const updateAlert = /* GraphQL */ `
  mutation UpdateAlert($input: UpdateAlertInput!) {
    updateAlert(input: $input) {
      id
      alertName
      alertType
      locationTag
      location
      model
      email
      tag
      node
      customService
      jsonObject
      subscribedLevelEntity
      phoneNumber
      notificationSettingsJson
      createdBy
    }
  }
`;
export const updateAlertStatus = /* GraphQL */ `
  mutation UpdateAlertStatus($input: UpdateAlertStatusInput!) {
    updateAlertStatus(input: $input) {
      id
      alertName
      alertType
      locationTag
      location
      model
      email
      tag
      node
      customService
      jsonObject
      subscribedLevelEntity
      phoneNumber
      notificationSettingsJson
      createdBy
    }
  }
`;
export const updateAdminEmailAlert = /* GraphQL */ `
  mutation UpdateAdminEmailAlert($input: UpdateAdminEmailAlertInput!) {
    updateAdminEmailAlert(input: $input) {
      id
      alertName
      alertType
      locationTag
      location
      model
      email
      tag
      node
      customService
      jsonObject
      subscribedLevelEntity
      phoneNumber
      notificationSettingsJson
      createdBy
    }
  }
`;
export const updateAdminSystemAlert = /* GraphQL */ `
  mutation UpdateAdminSystemAlert($input: UpdateAdminSystemAlertInput!) {
    updateAdminSystemAlert(input: $input) {
      id
      alertName
      alertType
      locationTag
      location
      model
      email
      tag
      node
      customService
      jsonObject
      subscribedLevelEntity
      phoneNumber
      notificationSettingsJson
      createdBy
    }
  }
`;
export const updateUserAlert = /* GraphQL */ `
  mutation UpdateUserAlert($input: UpdateUserAlertInput!) {
    updateUserAlert(input: $input) {
      id
      alertName
      alertType
      locationTag
      location
      model
      email
      tag
      node
      customService
      jsonObject
      subscribedLevelEntity
      phoneNumber
      notificationSettingsJson
      createdBy
    }
  }
`;
export const deleteAlert = /* GraphQL */ `
  mutation DeleteAlert($input: DeleteAlertInput!) {
    deleteAlert(input: $input) {
      id
      alertName
      alertType
      locationTag
      location
      model
      email
      tag
      node
      customService
      jsonObject
      subscribedLevelEntity
      phoneNumber
      notificationSettingsJson
      createdBy
    }
  }
`;
export const deleteZone = /* GraphQL */ `
  mutation DeleteZone($input: DeleteZoneInput!) {
    deleteZone(input: $input) {
      id
      name
      pan
      tilt
      deviceId
      status
      serviceId
      inspectTime
      keyFrame
      threshold {
        id
        name
        value
      }
      exclusions
      nodeId
      alertData
      zoom
      shouldNotify
      signedUrlKeyFrame
    }
  }
`;
export const deleteZoneThreshold = /* GraphQL */ `
  mutation DeleteZoneThreshold($id: ID!) {
    deleteZoneThreshold(id: $id) {
      id
      name
      value
    }
  }
`;
export const deleteAnnotation = /* GraphQL */ `
  mutation DeleteAnnotation($input: DeleteAnnotationInput!) {
    deleteAnnotation(input: $input) {
      id
      serviceId
      deviceId
      zoneId
      polygon
      annotationType
      equipmentType
      annotateTanks
      name
      tankNumber
      tankHeight
      bottomHidden
    }
  }
`;
export const deleteAllAnnotations = /* GraphQL */ `
  mutation DeleteAllAnnotations($input: DeleteAllAnnotationsInput!) {
    deleteAllAnnotations(input: $input) {
      id
      zoneId
    }
  }
`;
export const addNode = /* GraphQL */ `
  mutation AddNode($input: AddNodeInput!) {
    addNode(input: $input) {
      customerId
      locationId
      id
      nodeName
      nodeId
      level
      referenceId
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
      }
      serviceData
      deviceData
      onboardCommand
      tags {
        id
        tagName
      }
      nodeIP
      isOnline
    }
  }
`;
export const updateNode = /* GraphQL */ `
  mutation UpdateNode($input: UpdateNodeInput!) {
    updateNode(input: $input) {
      customerId
      locationId
      id
      nodeName
      nodeId
      level
      referenceId
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
      }
      serviceData
      deviceData
      onboardCommand
      tags {
        id
        tagName
      }
      nodeIP
      isOnline
    }
  }
`;
export const deleteNode = /* GraphQL */ `
  mutation DeleteNode($nodeId: String!) {
    deleteNode(nodeId: $nodeId) {
      customerId
      locationId
      id
      nodeName
      nodeId
      level
      referenceId
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
      }
      serviceData
      deviceData
      onboardCommand
      tags {
        id
        tagName
      }
      nodeIP
      isOnline
    }
  }
`;
export const deactivateNodeOnboardScript = /* GraphQL */ `
  mutation DeactivateNodeOnboardScript($locationId: String!, $nodeId: String!) {
    deactivateNodeOnboardScript(locationId: $locationId, nodeId: $nodeId) {
      customerId
      locationId
      id
      nodeName
      nodeId
      level
      referenceId
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
      }
      serviceData
      deviceData
      onboardCommand
      tags {
        id
        tagName
      }
      nodeIP
      isOnline
    }
  }
`;
export const updateUserSettings = /* GraphQL */ `
  mutation UpdateUserSettings(
    $customerId: String!
    $userId: String!
    $userSettings: UserSettingsInput!
  ) {
    updateUserSettings(
      customerId: $customerId
      userId: $userId
      userSettings: $userSettings
    ) {
      id
      externalId
      customer_id
      firstName
      lastName
      email
      user_role
      userSettings
    }
  }
`;
export const changeNodeStatus = /* GraphQL */ `
  mutation ChangeNodeStatus($input: ChangeNodeStatusInput!) {
    changeNodeStatus(input: $input)
  }
`;
export const updateProfile = /* GraphQL */ `
  mutation UpdateProfile($input: ProfileInput) {
    updateProfile(input: $input) {
      id
      name
      file
    }
  }
`;
export const edgeClientMessenger = /* GraphQL */ `
  mutation EdgeClientMessenger($message: EdgeClientMessageInput) {
    edgeClientMessenger(message: $message) {
      id
      statusCode
      topic
      payload
      payloadType
      timestamp
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      domains
      id
      externalId
      availableApps
      name
      pointOfContact
      totalLeakFinderLimit
      usageLeakFinderCount
      allowLeakFinder
      configuration
      auditCustomers
      aggAlertingData
      isQuantificationsDisabled
      devicePassword
    }
  }
`;
export const addLocation = /* GraphQL */ `
  mutation AddLocation($input: LocationInput!) {
    addLocation(input: $input) {
      id
      name
      referenceId
      locationData
      tags {
        id
        associationId
        tagName
      }
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
      }
      timeZone
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation($input: UpdateLocationInput!) {
    updateLocation(input: $input) {
      id
      name
      referenceId
      locationData
      tags {
        id
        associationId
        tagName
      }
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
      }
      timeZone
    }
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation($customerId: String!, $locationId: String!) {
    deleteLocation(customerId: $customerId, locationId: $locationId)
  }
`;
export const publishNode = /* GraphQL */ `
  mutation PublishNode($input: publishNodeInput!) {
    publishNode(input: $input) {
      nodeId
      message
    }
  }
`;
export const setPendingState = /* GraphQL */ `
  mutation SetPendingState($eventId: String, $customerId: String) {
    setPendingState(eventId: $eventId, customerId: $customerId) {
      id
      customerId
      locationId
      nodeId
      serviceId
      data
      validationState
      validated_by
      explanation
      eventTime
      audited_by
      transitionInfo
      auditorsExplanation
    }
  }
`;
export const takeEventToValidate = /* GraphQL */ `
  mutation TakeEventToValidate($eventId: String, $customerId: String) {
    takeEventToValidate(eventId: $eventId, customerId: $customerId) {
      id
      customerId
      locationId
      nodeId
      serviceId
      data
      validationState
      validated_by
      explanation
      eventTime
      audited_by
      transitionInfo
      auditorsExplanation
    }
  }
`;
export const takeEventToAudit = /* GraphQL */ `
  mutation TakeEventToAudit($eventId: String, $customerId: String) {
    takeEventToAudit(eventId: $eventId, customerId: $customerId) {
      id
      customerId
      locationId
      nodeId
      serviceId
      data
      validationState
      validated_by
      explanation
      eventTime
      audited_by
      transitionInfo
      auditorsExplanation
    }
  }
`;
export const validateEvent = /* GraphQL */ `
  mutation ValidateEvent($input: ValidateEventInput!) {
    validateEvent(input: $input) {
      id
      customerId
      locationId
      nodeId
      serviceId
      data
      validationState
      validated_by
      explanation
      eventTime
      audited_by
      transitionInfo
      auditorsExplanation
    }
  }
`;
export const overruleHumanValidatedEvents = /* GraphQL */ `
  mutation OverruleHumanValidatedEvents($input: ValidateEventInput!) {
    overruleHumanValidatedEvents(input: $input) {
      id
      customerId
      locationId
      nodeId
      serviceId
      data
      validationState
      validated_by
      explanation
      eventTime
      audited_by
      transitionInfo
      auditorsExplanation
    }
  }
`;
export const addDomain = /* GraphQL */ `
  mutation AddDomain($domain: String!, $customerId: String!) {
    addDomain(domain: $domain, customerId: $customerId) {
      customerId
    }
  }
`;
export const addDevice = /* GraphQL */ `
  mutation AddDevice($input: AddDeviceInput!) {
    addDevice(input: $input) {
      customerId
      locationId
      locationName
      id
      name
      status
      nodeId
      nodeName
      makeModelId
      cameraIpAddress
      deviceData {
        hasPanTilt
        hasRecordVideo
        hasZoom
        keyFrame
        panTiltIP
        protocol
        recentFrame
        rtspHost
        sourceVideo
        signedUrlKeyFrame
        signedUrlRecentFrame
      }
      currentPosition {
        pan
        tilt
        zoom
      }
      healthData {
        lastAlive
        isOnline
      }
    }
  }
`;
export const addDevicesTemplate = /* GraphQL */ `
  mutation AddDevicesTemplate($input: AddDevicesTemplateInput!) {
    addDevicesTemplate(input: $input) {
      id
      name
      numberOfNodes
      templateData
    }
  }
`;
export const updateDevice = /* GraphQL */ `
  mutation UpdateDevice($input: UpdateDeviceInput!) {
    updateDevice(input: $input) {
      customerId
      locationId
      locationName
      id
      name
      status
      nodeId
      nodeName
      makeModelId
      cameraIpAddress
      deviceData {
        hasPanTilt
        hasRecordVideo
        hasZoom
        keyFrame
        panTiltIP
        protocol
        recentFrame
        rtspHost
        sourceVideo
        signedUrlKeyFrame
        signedUrlRecentFrame
      }
      currentPosition {
        pan
        tilt
        zoom
      }
      healthData {
        lastAlive
        isOnline
      }
    }
  }
`;
export const deleteDevice = /* GraphQL */ `
  mutation DeleteDevice($customerId: String!, $deviceId: String!) {
    deleteDevice(customerId: $customerId, deviceId: $deviceId)
  }
`;
export const addDeviceMake = /* GraphQL */ `
  mutation AddDeviceMake($input: AddDeviceMakeInput!) {
    addDeviceMake(input: $input) {
      id
      name
      model
      type
      rtspTemplate
      defaultUserPwd
      hasPanTilt
      hasZoom
      modelsToRun
      deviceTypeShortName
    }
  }
`;
export const updateDeviceMake = /* GraphQL */ `
  mutation UpdateDeviceMake($input: UpdateDeviceMakeInput!) {
    updateDeviceMake(input: $input) {
      id
      name
      model
      type
      rtspTemplate
      defaultUserPwd
      hasPanTilt
      hasZoom
      modelsToRun
      deviceTypeShortName
    }
  }
`;
export const deleteDeviceMake = /* GraphQL */ `
  mutation DeleteDeviceMake($id: String!) {
    deleteDeviceMake(id: $id)
  }
`;
export const deleteDeviceTemplate = /* GraphQL */ `
  mutation DeleteDeviceTemplate($id: String!) {
    deleteDeviceTemplate(id: $id)
  }
`;
export const sendToListenToNodeMessages = /* GraphQL */ `
  mutation SendToListenToNodeMessages($nodeMessage: AWSJSON!) {
    sendToListenToNodeMessages(nodeMessage: $nodeMessage) {
      internalNodeId
      message
    }
  }
`;
export const sendToListenToNodeFiles = /* GraphQL */ `
  mutation SendToListenToNodeFiles($nodeFile: AWSJSON!) {
    sendToListenToNodeFiles(nodeFile: $nodeFile) {
      internalNodeId
      downloadURL
      file
    }
  }
`;
export const sendToListenToHumanValidationEvents = /* GraphQL */ `
  mutation SendToListenToHumanValidationEvents(
    $humanValidationEvent: AWSJSON!
  ) {
    sendToListenToHumanValidationEvents(
      humanValidationEvent: $humanValidationEvent
    ) {
      id
      customerId
      locationId
      nodeId
      serviceId
      data
      validationState
      validated_by
      explanation
      eventTime
      audited_by
      transitionInfo
      auditorsExplanation
    }
  }
`;
export const assignFirstRoleToUser = /* GraphQL */ `
  mutation AssignFirstRoleToUser(
    $customerId: String!
    $userId: String!
    $roleId: String!
    $groupId: String!
    $userPoolId: String
  ) {
    assignFirstRoleToUser(
      customerId: $customerId
      userId: $userId
      roleId: $roleId
      groupId: $groupId
      userPoolId: $userPoolId
    ) {
      id
      externalId
      customer_id
      firstName
      lastName
      email
      user_role
      userSettings
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $customerId: String!
    $userId: String!
    $userPoolId: String!
  ) {
    deleteUser(
      customerId: $customerId
      userId: $userId
      userPoolId: $userPoolId
    ) {
      id
      externalId
      customer_id
      firstName
      lastName
      email
      user_role
      userSettings
    }
  }
`;
export const updateNodeOnlineStatus = /* GraphQL */ `
  mutation UpdateNodeOnlineStatus($nodeId: String!, $isOnline: Boolean) {
    updateNodeOnlineStatus(nodeId: $nodeId, isOnline: $isOnline) {
      customerId
      locationId
      id
      nodeName
      nodeId
      level
      referenceId
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
      }
      serviceData
      deviceData
      onboardCommand
      tags {
        id
        tagName
      }
      nodeIP
      isOnline
    }
  }
`;
export const updateDeviceData = /* GraphQL */ `
  mutation UpdateDeviceData(
    $customerId: String!
    $deviceId: String!
    $deviceData: AWSJSON
  ) {
    updateDeviceData(
      customerId: $customerId
      deviceId: $deviceId
      deviceData: $deviceData
    ) {
      customerId
      locationId
      locationName
      id
      name
      status
      nodeId
      nodeName
      makeModelId
      cameraIpAddress
      deviceData {
        hasPanTilt
        hasRecordVideo
        hasZoom
        keyFrame
        panTiltIP
        protocol
        recentFrame
        rtspHost
        sourceVideo
        signedUrlKeyFrame
        signedUrlRecentFrame
      }
      currentPosition {
        pan
        tilt
        zoom
      }
      healthData {
        isOnline
        lastAlive
      }
    }
  }
`;
export const updateServiceHealth = /* GraphQL */ `
  mutation UpdateServiceHealth($input: UpdateServiceHealthInput!) {
    updateServiceHealth(input: $input) {
      nodeId
      customerId
      locationId
      deviceId
      serviceType
      configuration
      id
      healthData
      isRunning
    }
  }
`;
export const setExpectedOnline = /* GraphQL */ `
  mutation SetExpectedOnline($input: SetExpectedOnlineInput!) {
    setExpectedOnline(input: $input) {
      updatedCount
    }
  }
`;
export const updateHealthLeafMetadata = /* GraphQL */ `
  mutation UpdateHealthLeafMetadata($input: UpdateHealthLeafMetadataInput!) {
    updateHealthLeafMetadata(input: $input) {
      updatedCount
    }
  }
`;
export const deleteHealthLeaf = /* GraphQL */ `
  mutation DeleteHealthLeaf($input: DeleteHealthLeafInput!) {
    deleteHealthLeaf(input: $input) {
      deleted
      pk1
      sk
    }
  }
`;
